module.exports = __webpack_public_path__ + "img/bill.f02228bc.svg";